export const FIND_BY_USER_ID_AND_PERIOD = 'ORDERHISTORY:FIND_BY_USER_ID_AND_PERIOD';
export const FIND_ORDER_HISTORY_BY_USER_ID_SUCCESS = 'ORDERHISTORY:FIND_ORDER_HISTORY_BY_USER_ID_SUCCESS';
export const FIND_ORDER_HISTORY_BY_USER_ID_ERROR = 'ORDERHISTORY:FIND_ORDER_HISTORY_BY_USER_ID_ERROR';
export const SET_ORDER_HISTORY_LIST = 'ORDERHISTORY:SET_ORDER_HISTORY_LIST';